// removed by extract-text-webpack-plugin
module.exports = {"buttonWithOptions":"CentricUI__PageMenu__PageMenu__buttonWithOptions","pageButton":"CentricUI__PageMenu__PageMenu__pageButton","currentPage":"CentricUI__PageMenu__PageMenu__currentPage","pageMenuItem":"CentricUI__PageMenu__PageMenu__pageMenuItem","inputWrapper":"CentricUI__PageMenu__PageMenu__inputWrapper","editPageName":"CentricUI__PageMenu__PageMenu__editPageName","buttonBar":"CentricUI__PageMenu__PageMenu__buttonBar","frameContentItem":"CentricUI__PageMenu__PageMenu__frameContentItem"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/whiteboard/components/TopPanel/PageMenu/PageMenu.css
// module id = 1314
// module chunks = 10